import React, { useRef, useState } from "react";
import { motion, useScroll, useMotionValueEvent, AnimatePresence } from "framer-motion";
import { cn } from "../../lib/utils";

/* Aceternity sticky-scroll-reveal, adapted for BookingFlows — light theme,
   window-scroll driven. Left column scrolls text items; right column pins a
   swapping visual card. On mobile each item shows its visual inline. */
export const StickyScroll = ({ content, contentClassName }) => {
  const ref = useRef(null);
  const [activeCard, setActiveCard] = useState(0);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.55", "end 0.65"],
  });

  useMotionValueEvent(scrollYProgress, "change", (latest) => {
    const breakpoints = content.map((_, index) => index / content.length);
    const closest = breakpoints.reduce(
      (acc, bp, index) => (Math.abs(latest - bp) < Math.abs(latest - breakpoints[acc]) ? index : acc),
      0
    );
    setActiveCard(closest);
  });

  return (
    <div ref={ref} className="relative grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-20">
      <div>
        {content.map((item, index) => (
          <div
            key={item.title + index}
            className="flex flex-col justify-center py-12 lg:min-h-[26rem] lg:py-16"
            data-testid={`sticky-scroll-item-${index}`}
          >
            <motion.div
              animate={{ opacity: activeCard === index ? 1 : 0.3 }}
              transition={{ duration: 0.3 }}
              className="lg:pr-4"
            >
              {item.badge && (
                <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-blue-600/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-blue-700">
                  {item.badge}
                </div>
              )}
              <h3 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">{item.title}</h3>
              <div className="mt-4 max-w-md text-base leading-relaxed text-gray-500">{item.description}</div>
            </motion.div>
            <div className="mt-8 lg:hidden">{item.content}</div>
          </div>
        ))}
      </div>
      <div className="hidden lg:block">
        <div className={cn("sticky top-28 h-[28rem] overflow-hidden rounded-3xl", contentClassName)}>
          <AnimatePresence mode="wait">
            <motion.div
              key={activeCard}
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -18 }}
              transition={{ duration: 0.35, ease: "easeOut" }}
              className="h-full w-full"
            >
              {content[activeCard].content}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default StickyScroll;
